// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fbRgo","inputBox":"styles_inputBox__BWb+X","avatar":"styles_avatar__0TxPP"};